/**
*
* Publications
*
*/
import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import PublicationPage from 'Workspace/Publications/components/PublicationPage';
import HelpMenu from 'Workspace/components/WorkspaceHelpMenu';
const Publications = () => (
  <React.Fragment>
    <Switch>
      <Route exact path="/publications" component={PublicationPage} />
      <Redirect to="/publications" />
    </Switch>
    <HelpMenu />
  </React.Fragment>
);

export default Publications;
